<div *ngFor="let tableSection of tableSections" class="CommonTable EqualColumn">
  <div id="{{ tableSection.heading }}" *ngIf="tableSection.body" [innerHTML]="tableSection.body | mdToHtml"></div>
  <app-news-content-page-note-section [noteSections]="tableSection.noteSections || []"></app-news-content-page-note-section>
  <div *ngIf="tableSection.table" [innerHtml]="returnHtmlFromRichText(tableSection.table) | mdToHtml"></div>
</div>
